class navigationDrawer extends HTMLElement {
  constructor() {
    super();

    this.navHamburger = this.querySelector('[js-nav="hamburger"]');
    this.navDrawer = this.querySelector('[js-nav="drawer"]');
    this.navDrawerInner = this.querySelector('[js-nav="drawer-inner"]');
    this.navClose = this.querySelector('[js-nav="close"]');
    this.navBackdrop = this.querySelector('[js-nav="backdrop"]');
    this.header = document.querySelector('[js-nav="header"]');

    if (this.navHamburger && this.navDrawer && this.navDrawerInner) {
      this.navHamburger.addEventListener('click', (e) => {
        this.toggleDrawer();
      });
    }

    if (this.navDrawerInner) {
      this.navBackdrop.addEventListener('transitionend', () => {
        if (!this.navDrawerInner.classList.contains('is-active'))
          this.navDrawer.classList.remove('is-active');
      });
    }

    if (this.navClose) {
      this.navClose.addEventListener('click', (e) => {
        this.toggleDrawer();
        this.bodyUnlock();
      });
    }

    if (this.navBackdrop) {
      this.navBackdrop.addEventListener('click', (e) => {
        this.toggleDrawer();
      });
    }
  }

  toggleDrawer() {
    const drawerActive = this.navDrawer.classList.contains('is-active');

    if (drawerActive) {
      this.navDrawer.classList.remove('is-active');
      this.navDrawerInner.classList.remove('is-active');
      this.header.classList.remove('header--override');
      this.navHamburger.classList.remove('is-active');
    } else {
      if (window.scrollY === 0) {
        window.scrollTo({
          top: 50,
          behavior: 'smooth',
        });
      }

      this.navDrawer.classList.add('is-active');
      this.navDrawerInner.classList.add('is-active');
      this.header.classList.add('header--override');
      this.navHamburger.classList.add('is-active');
    }
  }

  bodyUnlock() {
    document.body.classList.remove('body-locked');
  }
}

customElements.define('navigation-drawer', navigationDrawer);
